<template>
  <div class="backdrop" :class="{ 'backdrop--active': getBackdropIsActive }"></div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('layout', ['getBackdropIsActive']),
    },
  };
</script>

<style scoped lang="scss">
  .backdrop {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    //
    position: fixed;
    top: 0;
    //
    transition: opacity 200ms cubic-bezier(0, 0, 0, 1), left 0ms 200ms;
    left: -9999px;
    opacity: 0;

    &--active {
      transition: opacity 200ms cubic-bezier(0, 0, 0, 1), left 0ms 0ms;
      left: 0;
      opacity: 1;
    }
  }
</style>
